<template>
    <span
        class="text-danger float-left mr-1"
        v-if="convenio.idSituacaoConvenio != 9">
        <i
            class="fa fa-ban fa-lg icon-button"
            title="Cancelar Ação"
            @click.stop="confirmarCancelar(acao.idAcaoPlanoTrabalho)"
        ></i>
    </span>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'

export default {
    props: {
        convenio: Object,
        acao: Object
    },

    data() {
        return {}
    },

    methods: {
        confirmarCancelar(id) {
            this.$swal({
                title: 'Cancelar',
                html:
                    'Deseja Cancelar a Ação <strong>' +
                    this.acao.nomeAcao +
                    '</strong> ?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.cancelar(id)
                }
            })
        },

        cancelar(id) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.cancelarAcaoPlanoTrabalho(id).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Ação cancelada com sucesso',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizarLista')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },
    }
}
</script>
